import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Avatar,
  Box,
  Typography,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../util/auth';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 12px;
    max-width: 500px;
    width: 100%;
  }
`;

const ProfileHeader = styled(Box)`
  text-align: center;
  padding: 24px;
  background: #f8f9fa;
  position: relative;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
`;

const AvatarWrapper = styled(Box)`
  margin-bottom: 16px;
`;

const FormSection = styled(Box)`
  padding: 24px;
  
  .MuiTextField-root {
    margin-bottom: 16px;
  }
`;

function UserProfileModal({ open, onClose }) {
  const auth = useAuth();
  const [name, setName] = React.useState(auth.user?.displayName || '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Add profile update logic here
    // For now, just close the modal
    onClose();
  };

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth>
      <ProfileHeader>
        <CloseButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </CloseButton>
        <AvatarWrapper>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              margin: '0 auto',
              bgcolor: 'primary.main',
              fontSize: '2rem'
            }}
          >
            {auth.user?.email?.[0]?.toUpperCase()}
          </Avatar>
        </AvatarWrapper>
        <Typography variant="h6" gutterBottom>
          User Profile
        </Typography>
      </ProfileHeader>

      <DialogContent>
        <FormSection component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
            disabled
          />
          <TextField
            fullWidth
            label="Email"
            value={auth.user?.email}
            variant="outlined"
            disabled
          />
        </FormSection>
      </DialogContent>

      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={() => {
            auth.signout();
            onClose();
          }}
          color="primary"
          variant="contained"
        >
          Sign Out
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}

export default UserProfileModal; 